/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import PropTypes from 'prop-types';
import Navbar from './Navbar/Navbar';
import {
  layoutStyles, bodyStyles, childrenStyles, centeredChildrenStyles,
} from './layout.styles';

const Layout = ({
  containerStyles,
  childrenContainerStyles,
  sidebar,
  children,
}) => (
  <div css={[layoutStyles, containerStyles]}>
    <Navbar />
    <div css={bodyStyles}>
      {sidebar}
      <main css={[childrenStyles, !sidebar && centeredChildrenStyles, childrenContainerStyles]}>
        {children}
      </main>
    </div>
  </div>
);

Layout.propTypes = {
  containerStyles: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  childrenContainerStyles: PropTypes.shape({}),
  sidebar: PropTypes.node,
  children: PropTypes.node.isRequired,
};

Layout.defaultProps = {
  containerStyles: css``,
  childrenContainerStyles: css``,
  sidebar: '',
};

export default Layout;
